import { useMemo, useCallback } from "react";

import {
	findColumnInAll,
	getAllColumns,
	getIsRowLayout,
	mapFormattersFromColumns,
} from "./helpers";

type UseFiltersProvidersProps = {
	columns: any[];
	expandableRows: any[];
};

const useFiltersProvider = ({
	columns,
	expandableRows,
}: UseFiltersProvidersProps) => {
	// prettier-ignore
	const allColumns = useMemo(
		() => getAllColumns(columns, expandableRows),
		[columns, expandableRows]
	);

	const rowLength = useMemo(
		() =>
			getIsRowLayout(columns)
				? Math.max(...columns.map(c => c.length))
				: columns.length,
		[columns],
	);

	const findColumn = useCallback(
		(filterKey: string) => {
			return findColumnInAll(allColumns, filterKey);
		},
		[allColumns],
	);

	const isLabelForMultiValue = useCallback(
		(filterKey: string) => {
			return allColumns.some(c => {
				if (c.name === filterKey) {
					return "isMultiValue" in c && c.isMultiValue;
				} else {
					return false;
				}
			});
		},
		[allColumns],
	);

	// prettier-ignore
	const formatLabels = useMemo(
		() => mapFormattersFromColumns(allColumns),
		[allColumns],
	);

	const layoutContainerStyle = useMemo(
		() => ({ style: { "--row-length": rowLength } }),
		[rowLength],
	);

	return {
		allColumns,
		rowLength,
		layoutContainerStyle,
		findColumn,
		isLabelForMultiValue,
		formatLabels,
	};
};

export default useFiltersProvider;
